import type { OrderNotice } from '../../Generated/OrderNotice.ts'
import type { NoticeTargetKey } from '../../Generated/NoticeTarget.ts'
import type { NoticeVisibilityKey } from '../../Generated/NoticeVisibility.ts'
import type { OrderAlert } from './orderAlerts.ts'

export const openNotices = (notices: OrderNotice[]): OrderNotice[] => notices.filter((n) => !n.resolvedAt)

/** The open notices concerning one order action, for the warning marker on its control. */
export const openNoticesFor = (notices: OrderNotice[], target: NoticeTargetKey): OrderNotice[] =>
  openNotices(notices).filter((n) => n.targets?.includes(target))

/** Who else can read a notice; null for one every order member sees, which needs no label. */
export const restrictedAudience = (visibility: NoticeVisibilityKey): string | null =>
  ({ INTERNAL: 'spcfy staff only', ADMIN: 'admins only', USER: null })[visibility]

export const noticeAlerts = (notices: OrderNotice[]): OrderAlert[] =>
  notices.map((n) => ({
    id: `notice:${n.id}`,
    title: n.title,
    body: n.body,
    audience: restrictedAudience(n.visibility),
    resolved: !!n.resolvedAt
  }))
